/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { injectIntl, FormattedMessage } from "react-intl";
import { Button, WhiteSpace, Radio, Toast } from "antd-mobile";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import TextInput from "../../../components/TextInput";
import Theme from "../../../utils/Theme";
import {
  identifyMobileNumError,
  identifyPasswordError,
  validateMobileNum,
  validatePassword
} from "../../../utils/FieldValidator";
import * as authActions from "../../../actions/auth";
import * as selectors from "../../../selectors";
import "./index.css";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0.5em 1.4em;
  justify-content: center;
  text-align: center;
  color: grey;
`;

const StyledRememberSectionContainer = styled.div`
  font-size: 0.9em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.8em;
`;

const StyledRegisterSectionContainer = styled.div`
  font-size: 0.9em;
`;

const StyledRoundedButton = styled(Button)`
  && {
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
  }
`;

const StyledLoginButton = styled(StyledRoundedButton)`
  && {
    background-color: ${Theme.PrimaryColor};
  }
`;

const StyledFacebookButton = styled(StyledRoundedButton)`
  && {
    background-color: #3b5998;
  }
`;

const StyledLink = styled(Link)`
  color: red;
`;

class LoginSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      facebook_loading: false,
      mobile_number: {
        value: "",
        error: false,
        error_message: ""
      },
      password: {
        value: "",
        error: false,
        error_message: ""
      },
      remember_me: false
    };
  }

  componentDidMount() {
    const { rememberMe, mobileNumber } = this.props;

    this.setState({
      mobile_number: {
        value: mobileNumber,
        error: false,
        error_message: ""
      },
      remember_me: rememberMe
    });
    this.FB = window.FB;
  }

  validateFields = () => {
    const { mobile_number, password } = this.state;

    if (!validateMobileNum(mobile_number.value)) {
      mobile_number.error = true;
      mobile_number.error_message = identifyMobileNumError(mobile_number.value);
    } else {
      mobile_number.error = false;
      mobile_number.error_message = "";
    }

    if (!validatePassword(password.value)) {
      password.error = true;
      password.error_message = identifyPasswordError(password.value);
    } else {
      password.error = false;
      password.error_message = "";
    }

    this.setState({
      mobile_number: mobile_number,
      password: password
    });
  };

  onSubmit = () => {
    const { logInRequest } = this.props;
    const { mobile_number, password, remember_me } = this.state;
    const mobileNum =
      this.state.mobile_number.value !== null
        ? this.state.mobile_number.value.replace(/\s/g, "")
        : "";
    const passwordNum = this.state.password.value;

    this.validateFields();

    if (logInRequest && !mobile_number.error && !password.error) {
      logInRequest(mobileNum, passwordNum, remember_me);
    }
  };

  onFacebookSubmit = () => {
    if (!this.FB) return;

    this.FB.login(this.facebookLoginHandler, {
      scope: "public_profile,email"
    });
    this.setState({ facebook_loading: true });
  };

  facebookLoginHandler = response => {
    const { intl } = this.props;

    if (response.status === "connected") {
      const { accessToken } = response.authResponse;
      const { facebookLoginRequest } = this.props;

      if (facebookLoginRequest && accessToken) {
        facebookLoginRequest(accessToken);
      }
    } else {
      Toast.fail(
        intl.formatMessage({
          id: "auth.login.facebook.failed",
          defaultMessage: "Failed to login with Facebook"
        })
      );
    }
    this.setState({ facebook_loading: false });
  };

  onRememberBtnClick = () => {
    const { remember_me } = this.state;

    this.setState({
      remember_me: !remember_me
    });
  };

  onMobileNumberChange = txt => {
    this.setState({
      mobile_number: {
        value: txt,
        error: false,
        error_message: ""
      }
    });
  };

  onPasswordChange = txt => {
    this.setState({
      password: {
        value: txt,
        error: false,
        error_message: ""
      }
    });
  };

  render() {
    const {
      remember_me,
      facebook_loading,
      mobile_number,
      password
    } = this.state;
    const { intl, loginLoading } = this.props;

    return (
      <StyledContainer>
        <TextInput
          type={"mobile"}
          defaultValue={this.props.mobileNumber}
          disabled={loginLoading || facebook_loading}
          error={mobile_number.error}
          onChange={txt => this.onMobileNumberChange(txt)}
          onErrorClick={() => {
            Toast.fail(
              intl.formatMessage({
                id: mobile_number.error_message,
                defaultMessage: "Invalid Mobile Number Format"
              })
            );
          }}
        />
        <TextInput
          type={"password"}
          disabled={loginLoading || facebook_loading}
          error={password.error}
          onChange={txt => this.onPasswordChange(txt)}
          onErrorClick={() => {
            Toast.fail(
              intl.formatMessage({
                id: password.error_message,
                defaultMessage: "Invalid Password Format"
              })
            );
          }}
        />
        <WhiteSpace size={"xs"} />
        <StyledRememberSectionContainer>
          <Radio
            checked={remember_me}
            className="remember-radio"
            onClick={() => this.onRememberBtnClick()}
          >
            <FormattedMessage
              id="app.remember.me"
              defaultMessage="Remember me"
              description="Remember Me Title"
            />
          </Radio>
          <StyledLink to="/forgot-password">
            <FormattedMessage
              id="auth.login.forget.password"
              defaultMessage="Forgot Password?"
              description="Forgot Password Title"
            />
          </StyledLink>
        </StyledRememberSectionContainer>
        <WhiteSpace size={"xl"} />
        <StyledLoginButton
          disabled={loginLoading || facebook_loading}
          loading={loginLoading}
          activeStyle={{ backgroundColor: Theme.ActivePrimary }}
          onClick={() => this.onSubmit()}
        >
          {loginLoading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="auth.login.title"
              defaultMessage="Login"
              description="Login title button at auth page"
            />
          )}
        </StyledLoginButton>
        <WhiteSpace size={"md"} />
        <StyledRegisterSectionContainer>
          <FormattedMessage
            id="auth.login.description"
            defaultMessage="Dont' have an account? {registerTitle}"
            description="Login description"
            values={{
              registerTitle: (
                <StyledLink to="/register">
                  <FormattedMessage
                    id="auth.signup.title"
                    defaultMessage="Register now"
                    description="Register Title"
                  />
                </StyledLink>
              )
            }}
          />
        </StyledRegisterSectionContainer>
        <WhiteSpace size={"xl"} />
        <StyledFacebookButton
          disabled={loginLoading || facebook_loading}
          loading={facebook_loading}
          activeStyle={{ backgroundColor: "RGBA(59, 89, 152, 0.8)" }}
          onClick={() => this.onFacebookSubmit()}
          icon={<FaFacebookF color={"white"} />}
        >
          {facebook_loading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="auth.login.facebook"
              defaultMessage="Continue with Facebook"
              description="Login with facebook title button"
            />
          )}
        </StyledFacebookButton>
        <WhiteSpace size={"xl"} />
      </StyledContainer>
    );
  }
}

LoginSection.propTypes = {
  intl: PropTypes.object,
  logInRequest: PropTypes.func.isRequired,
  facebookLoginRequest: PropTypes.func.isRequired,
  loginLoading: PropTypes.bool,
  rememberMe: PropTypes.bool,
  mobileNumber: PropTypes.string
};

const mapStateToProps = state => {
  return {
    loginLoading: selectors.getAuthLoginLoading(state),
    rememberMe: selectors.getAuthRememberMe(state),
    mobileNumber: selectors.getAuthMobileNumber(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logInRequest: (mobileNumber, password, rememberMe) =>
      dispatch(
        authActions.loginAccountRequest(mobileNumber, password, rememberMe)
      ),
    facebookLoginRequest: fbAccessToken =>
      dispatch(authActions.loginWithFacebookRequest(fbAccessToken))
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginSection)
);



// WEBPACK FOOTER //
// ./src/containers/AuthPage/LoginSection/index.js